export default __webpack_public_path__ + "static/media/Test3.85704059.jpg";